import React, { useState, useEffect, useMemo } from "react";
import { MasterInfoItem } from "./masterInfoItem";
import { masterType } from "../../utils";
import { CreateLanguageWithCity } from "../createView/createLanguageWithCity";
import CameraControls from "./CameraControls";
import PropTypes from "prop-types";
import { useCameraOperations } from "./hooks/useCameraOperations";

export const VehicleMasterView = (props) => {
    const [showStream, setShowStream] = useState(false);
    const [streamError, setStreamError] = useState(false);

    const isCamera = props.masterType === masterType.camera;
    const isLanguage = props.masterType === masterType.language;

    const handleStreamStart = () => {
        setShowStream(true);
        setStreamError(false);
    };

    const handleStreamStop = () => {
        setShowStream(false);
        setStreamError(false);
    };

    const handleStreamRetry = () => {
        setStreamError(false);
        setShowStream(false);
        setTimeout(() => {
            setShowStream(true);
        }, 500);
    };

    const handleStreamError = (hasError) => {
        setStreamError(hasError);
    };

    const email = useMemo(() => localStorage.getItem("userName"), []);

    const {
        cameraHealthDetails,
        loadingHealthDetails,
        cameraRestartResponse,
        sdCardFormatResponse,
        cameraRestart,
        sdCardFormat,
        fetchCameraStatusData,
        fetchCameraHealthDetailsData,
        handleCameraRestart,
        handleSDCardFormat,
    } = useCameraOperations(props.data?.cameraId, email);

    useEffect(() => {
        if (isCamera && props.data?.cameraId) {
            fetchCameraStatusData();
            fetchCameraHealthDetailsData();
        }
    }, [props.data?.cameraId, isCamera, fetchCameraStatusData, fetchCameraHealthDetailsData]);

    const displayData = useMemo(() => {
        if (isCamera && cameraHealthDetails && !loadingHealthDetails) {
            return { ...props.data, ...cameraHealthDetails };
        }
        return props.data;
    }, [isCamera, cameraHealthDetails, loadingHealthDetails, props.data]);

    const propsForCreateLanguageWithCity = useMemo(() => ({
        initiateNotification: props.initiateNotification,
        onComplete: props.onComplete,
        onClose: props.onClose,
        editMode: true,
        serverRow: props.data,
        synLanguageTableAfterIndividualLangRemove: props.synLanguageTableAfterIndividualLangRemove,
    }), [
        props.initiateNotification,
        props.onComplete,
        props.onClose,
        props.data,
        props.synLanguageTableAfterIndividualLangRemove,
    ]);

    return (
        <div>
            <div className="row vehicle-info">
                <div className={isCamera ? "col-sm-6" : "col-sm-12"}>
                    {Object.keys(displayData).map((columnKey) => (
                        <MasterInfoItem
                            key={columnKey}
                            label={columnKey}
                            value={displayData[columnKey]}
                            masterType={props.masterType}
                            data={displayData}
                            onClose={props.onClose}
                            initiateNotification={props.initiateNotification}
                            cityViewProps={props}
                        />
                    ))}
                </div>

                {isCamera && (
                    <CameraControls
                        cameraId={props.data?.cameraId}
                        showStream={showStream}
                        onStreamStart={handleStreamStart}
                        onStreamStop={handleStreamStop}
                        onStreamRetry={handleStreamRetry}
                        onStreamError={handleStreamError}
                        streamError={streamError}
                        cameraRestartResponse={cameraRestartResponse}
                        sdCardFormatResponse={sdCardFormatResponse}
                        cameraRestart={cameraRestart}
                        sdCardFormat={sdCardFormat}
                        onCameraRestart={handleCameraRestart}
                        onSDCardFormat={handleSDCardFormat}
                    />
                )}

                {isLanguage && (
                    <div className="col-sm-12">
                        <CreateLanguageWithCity
                            {...propsForCreateLanguageWithCity}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

VehicleMasterView.propTypes = {
    data: PropTypes.object.isRequired,
    masterType: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    initiateNotification: PropTypes.func.isRequired,
    synLanguageTableAfterIndividualLangRemove: PropTypes.func,
};
